<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-user-tie"></i> Movimentação de Associados - {{$lang.RelationchipManager.Label}}</h3>
      </div>
    </div>

    <Forms ref="frmGroup"
      :title="'MOVIMENTAÇÃO DE ASSOCIADOS'"
      :showSaveButton="true"
      v-on:Save="openConfirmationModal">
      <div class="form-group row">
        <div class="col-md-4 offset-md-1">
          <label><small v-show="form.paId.required" class="text-danger">*</small> PA:</label>
          <div class="input-group">

            <v-select v-model="form.paId.value"
                      :options="form.paId.options"
                      class="w-100"
                      label="text"
                      :reduce="(opt) => opt.value"
                      @input="onSearch">
              <template v-slot:no-options>Nenhum pa encontrado.</template>
            </v-select>
          </div>
        </div>

        <div class="col-md-4 offset-md-2 pb-3">
          <label><small v-show="form.gerenteRelacionamentoId.required" class="text-danger">*</small> {{$lang.RelationchipManager.Label}}:</label>
          <div class="input-group">

            <v-select v-model="form.gerenteRelacionamentoId.value"
                      :options="form.gerenteRelacionamentoId.options"
                      class="w-100"
                      label="text"
                      :reduce="(opt) => opt.value">
              <template v-slot:no-options>Nenhum funcionário encontrado.</template>
            </v-select>
          </div>
        </div>

      </div>

      <div class="form-group row pt-3">
        <div class="col-md-4">
          <div class="input-group">
            <b-form-input type="text"
              :placeholder="'Digite a Busca'"
              :disabled="allSelected"
              v-model="searchValue"
              @keyup.enter.stop="onSearch"></b-form-input>
              <span class="input-group-addon" @click="onSearch"><i class="fas fa-search"></i></span>
          </div>
        </div>
      </div>

      <div id="associate-list" style="overflow-y: auto; max-height:70vh;">
        <table class="table table-hover" style="border: 1px solid #dcdede;" >
          <thead class="thead-third" style="border: solid 1px #0277bd; height: 44px;">
            <tr>
              <th class="text-center col-1"><input type="checkbox" v-model="selectAll" v-if="!searchValue"></th>
              <th class="text-center">Nome</th>
              <th class="text-center">Numero Sisbr</th>
            </tr>
          </thead>
          <tr v-for="associado in associadosHasNotGerenteRelacionamento" :key="associado.id">
            <td v-if="allSelected" class="text-center col-1"><input v-model="allSelected" type="checkbox" checked disabled/></td>
            <td v-else class="text-center col-1"><input v-model="selected" :value="associado.id" type="checkbox"/></td>
            <td class="text-center">{{associado.nome}}</td>
            <td class="text-center">{{associado.numSisbr}}</td>
          </tr>
        </table>
      </div>
      <AssociatePagination  ref="AssociatePagination" @LoadPage="LoadPage" class="pt-3"></AssociatePagination>
      <div class="d-flex" style="justify-content: end; align-items: start; gap: 1rem; cursor:pointer;" @click="toggleCreateCard">
        <ToogleSwitch :value="createCard"/>
        <h5 style="line-height: 100%">Criar Oportunidade</h5>
      </div>
      <section v-if="createCard" class="create__card__container pb-4">
        <hr>
        <h4 class="mb-4"><i class="fas fa-address-card"></i> Nova Oportunidade</h4>
        <div class="input-group" style="background: none">
          <div class="col-md-6">
            <SelectBoard @onSelect="loadColumns" :onlyActive="true"/>
          </div>
          <div class="col-md-6">
            <SelectBoardColumn v-if="newCard.board" @onSelect="saveBoardAndColumn" :boardId="newCard.board" :key="newCard.board"/>
          </div>
          <div class="col-md-12 pt-3">
            <SelectOrigem v-if="newCard.boardColumn" @onSelect="saveOrigin"/>
          </div>
        </div>
      </section>
      <AddConfirmation ref="AddConfirmationModal"
                       :warnText="`Confirmar movimentação de  ${allSelected ? 'todos':this.selected.length} associados? `"
                       :saveFunction="updateGerentesRelacionamento"/>
    </Forms>
  </div>
  </template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import LinkForm from './link-form'
import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import { JWTService } from '@/shared/services/jwt'
import Roles from '@/shared/utils/roles.js'

import EmployeeRepository from '@/shared/http/repositories/configurations/employee'
import PARepository from '@/shared/http/repositories/configurations/pa'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import MovimentationRepository from '@/shared/http/repositories/configurations/movimentation.js'
import AssociatePagination from '@/views/private/associate/pagination/associatepagination.vue'
import SelectBoard from '@/components/forms/selects/SelectBoard.vue'
import SelectBoardColumn from '@/components/forms/selects/SelectBoardColumn.vue'
import SelectOrigem from '@/components/forms/selects/SelectOrigem.vue'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'

const dataModel = {
  gerenteRelacionamentoId: null,
  paId: null,
  openCards: false
}

export default {
  name: 'linkClusters',
  mixins: [ActionsForm],
  data () {
    return {
      data: dataModel,
      form: LinkForm,
      roles: Roles,
      permissions: null,
      pageLimit: 50,
      pageIndex: 0,
      currentPage: 0,
      totalElements: 0,
      numberOfElementsDisplayed: 0,
      offset: 0,
      allSelected: false,
      selected: [],
      searchValue: '',
      associadosHasNotGerenteRelacionamento: [],
      createCard: false,
      newCard: {
        board: null,
        boardColumn: null,
        origin: null
      }
    }
  },
  components: {
    AddConfirmation,
    AssociatePagination,
    ToogleSwitch,
    SelectBoard,
    SelectBoardColumn,
    SelectOrigem
  },
  computed: {
    selectAll: {
      get: function () {
        return this.allSelected
      },
      set: function () {
        if (this.allSelected) {
          this.allSelected = false
        } else {
          this.allSelected = true
        }
      }
    }
  },
  methods: {
    onLoad () {
      loading.push()
      this.permissions = JWTService.GetRoles()
      if (this.hasRole(this.roles.ADMINISTRADOR)) {
        EmployeeRepository.GetAll()
          .then((res) => {
            this.form.gerenteRelacionamentoId.options = res.data.content.map((x) => ({'value': x.id, 'text': x.pessoa.nome}))
            loading.pop()
          })
          .catch(this.onException)
        PARepository.GetAll()
          .then((res) => {
            loading.pop()
            this.form.paId.options = res.data.content.map((x) => ({'value': x.id, 'text': x.numero + ' - ' + x.descricao}))
          })
          .catch(this.onException)
      } else {
        PARepository.GetAllByUser(JWTService.GetUserName())
          .then((res) => {
            loading.pop()
            this.form.paId.options = res.data.paDTOList.map((x) => ({'value': x.id, 'text': x.numero + ' - ' + x.descricao}))
            this.form.gerenteRelacionamentoId.options = res.data.funcionarioDTOList.map((x) => ({'value': x.id, 'text': x.pessoa.nome}))
          })
          .catch(this.onException)
      }
    },
    loadAssociadosPa () {
      loading.push()
      if (this.form.paId.value !== null) {
        MovimentationRepository.GetAll(this.form.paId.value, this.searchValue, this.pageLimit, this.pageIndex)
          .then((res) => {
            this.associadosHasNotGerenteRelacionamento = res.data.content.map((x) => ({'id': x.id, 'nome': x.pessoa.nome, 'numSisbr': x.numSisbr}))
            this.$refs.AssociatePagination.totalPages = res.data.totalPages
            this.$refs.AssociatePagination.totalElements = res.data.totalElements
            this.$refs.AssociatePagination.numberOfElementsDisplayed = res.data.numberOfElements
            this.$refs.AssociatePagination.offset = res.data.pageable.offset
            loading.pop()
          })
          .catch(this.onException)
      } else {
        loading.pop()
        this.associadosHasNotGerenteRelacionamento = []
        this.selected = []
        this.$refs.AssociatePagination.totalPages = 0
        this.$refs.AssociatePagination.totalElements = 0
        this.$refs.AssociatePagination.numberOfElementsDisplayed = 0
        this.$refs.AssociatePagination.offset = 0
      }
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    },
    onSearch () {
      if (!this.allSelected) {
        this.onClearPaging()
        this.LoadPage(this.pageIndex)
      }
    },
    onClearPaging () {
      this.currentPage = 0
      this.pageIndex = 0
      this.$refs.AssociatePagination.currentPage = this.currentPage
      this.$refs.AssociatePagination.pageIndex = this.pageIndex
      this.$refs.AssociatePagination.totalElements = this.totalElements
      this.$refs.AssociatePagination.numberOfElementsDisplayed = this.numberOfElements
      this.$refs.AssociatePagination.offset = this.offset
    },
    updateGerentesRelacionamento () {
      // VERIFY IF IS TRYING TO CREATE CARDS AND ALL FIELDS ARE SELECTED
      if (this.createCard && !this.checkFieldsCreateCard()) return
      else if (this.createCard) {
        this.data.openCards = true
        this.data.boardId = this.newCard.board
        this.data.boardColumnId = this.newCard.boardColumn
        this.data.origemLeadId = this.newCard.origin
      }
      if (!Tools.ValidateForms(this.form, this.data, this, toast)) {
        return
      }
      if (this.allSelected) {
        this.data.associadoId = []
      } else {
        if (this.selected.length < 1) {
          toast.warning('Nenhum associado selecionado')
          return
        }
        this.data.associadoId = this.selected
      }
      this.data.filtroNome = this.searchValue
      loading.push()
      AssociateRepository.updateAllGerenteRelacionamento(this.data)
        .then(() => {
          toast.success(this.$lang.Common.Alerts.Success)
          this.reloadPage()
          loading.pop()
        })
        .catch(this.onException)
    },
    reloadPage () {
      this.selected = []
      this.searchValue = ''
      this.associadosHasNotGerenteRelacionamento = []
      this.newCard = {
        board: null,
        boardColumn: null,
        origin: null
      }
      this.onSearch()
    },
    LoadPage (index) {
      this.currentPage = index
      this.pageIndex = index
      if (this.searchValue !== null && this.searchValue !== '') {
        this.loadAssociadosPaWithFilter()
      } else {
        this.loadAssociadosPa()
      }
      var obj = document.getElementById('associate-list')
      obj.scrollTo(0, 0)
      // window.scrollTo(0, 0)
    },
    loadAssociadosPaWithFilter () {
      loading.push()
      if (this.form.paId.value !== null) {
        AssociateRepository.GetAllHasNotGerenteRelacionamento(this.form.paId.value, encodeURIComponent(this.searchValue), this.pageLimit, this.pageIndex)
          .then((res) => {
            this.associadosHasNotGerenteRelacionamento = res.data.content.map((x) => ({'id': x.id, 'nome': x.pessoa.nome, 'numSisbr': x.numSisbr}))
            this.$refs.AssociatePagination.totalPages = res.data.totalPages
            this.$refs.AssociatePagination.totalElements = res.data.totalElements
            this.$refs.AssociatePagination.numberOfElementsDisplayed = res.data.numberOfElements
            this.$refs.AssociatePagination.offset = res.data.pageable.offset
            loading.pop()
          })
          .catch(this.onException)
      } else {
        loading.pop()
        this.associadosHasNotGerenteRelacionamento = []
        this.selected = []
      }
    },
    toggleCreateCard () {
      this.createCard = !this.createCard
      this.newCard = {
        board: null,
        boardColumn: null,
        origin: null
      }
    },
    loadColumns (boardId) {
      this.newCard.board = boardId
    },
    saveBoardAndColumn (boardAndColumn) {
      this.newCard.board = boardAndColumn[0]
      this.newCard.boardColumn = boardAndColumn[1]
    },
    saveOrigin (origin) {
      this.newCard.origin = origin
    },
    checkFieldsCreateCard () {
      if (this.newCard.board && this.newCard.boardColumn && this.newCard.origin) return true
      else {
        toast.warning('Todos os campos devem estar preenchidos', 'Criar oportunidades')
        return false
      }
    },
    openConfirmationModal () {
      this.$nextTick(() => {
        this.$refs['AddConfirmationModal'].showModal()
      })
    }
  }
}
</script>

<style scoped>
  td{
    background-color: whitesmoke;
  }
  .input-group{
    background-color: whitesmoke;
  }
  thead{ position: sticky; top: 0; z-index: 1; }
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/movimentacoes/gerentesRelacionamento/link.vue